import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PathSanitizer = (): null => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (search && !search.startsWith("?token")) {
      navigate(pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
};

export default PathSanitizer;
